export default "/images/vendor/@coreui/icons/svg/flag/cif-ci.svg?f402944e0edd99042f453241a0a623c8";